import { useQuery } from '@tanstack/react-query'
import { apiV3PostsPath } from 'lib/urls'
import PostCardRow from 'hello_baby/components/post-card-row/post-card-row'
import classNames from 'classnames'
import { GuidesSection as GuidesSectionType } from '../../LandingPage.types'
import css from './GuidesSection.styles.scss'

interface GuidesSectionProps {
  section: GuidesSectionType
}

const GuidesSection = ({ section }: GuidesSectionProps) => {
  const {
    slugs,
    includeVerticalSectionSpacing,
    background,
    desktopWidth,
    columns = 4,
  } = section

  const { data } = useQuery({
    queryKey: [`guides-section-${section.id}`],
    queryFn: () =>
      fetch(`${apiV3PostsPath}?slugs[]=${slugs.join('&slugs[]=')}`).then(
        (res) => res.json()
      ),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })

  if (!data?.posts) return null

  const { posts } = data

  // Pregnancy Week By Week is not exactly a post, so create a 'post'
  // which can be rendered by PostCard
  if (slugs.length !== posts.length) {
    posts.push({
      id: 'pregnancy-week-by-week',
      title: 'Pregnancy Week By Week',
      meta: {
        topics: ['pregnancy-week-by-week'],
      },
      teaserText: '',
      featuredImage: {
        url: 'https://res.cloudinary.com/babylist/image/upload/v1580772079/pregnancy-week-by-week_kbbnyk.jpg',
      },
      slug: 'pregnancy-week-by-week',
    })
  }

  return (
    <div
      className={classNames(css.GuidesSection__container, {
        [css[`GuidesSection__container__background--${background}`]]:
          !!background,
        [css['GuidesSection__container--includeVerticalSectionSpacing']]:
          includeVerticalSectionSpacing,
        [css['GuidesSection__container--fullWidthSection']]:
          desktopWidth === 'full',
      })}
    >
      {data && <PostCardRow columns={columns} posts={posts} />}
    </div>
  )
}

export default GuidesSection
